"use client"

import React, {
  createContext,
  useContext,
  ReactNode,
} from "react"
import { Locale, defaultLocale } from "../../lib/i18n"

interface LocaleContextType {
  locale: Locale
}

// Create context with default values
const LocaleContext = createContext<LocaleContextType>({
  locale: defaultLocale,
})

interface LocaleProviderProps {
  children: ReactNode
  locale: Locale
}

/**
 * Provider component that makes locale data available to any child component
 */
export const LocaleProvider: React.FC<LocaleProviderProps> = ({
  children,
  locale,
}) => {
  return (
    <LocaleContext.Provider
      value={{
        locale,
      }}
    >
      {children}
    </LocaleContext.Provider>
  )
}

/**
 * Hook to use the locale context
 */
export const useLocaleContext = (): LocaleContextType => {
  const context = useContext(LocaleContext)

  if (context === undefined) {
    throw new Error("useLocale must be used within a LocaleProvider")
  }

  return context
}
